import { Label } from '@/Models/GenericWorklist/Label';
import { DobButton, DobDropdownMenu, DobDropdownMenuArrow, DobDropdownMenuItem, DobDropdownMenuSub, DobDropdownMenuSubContent, DobDropdownMenuSubTrigger } from '@dedalusdiit/dob-components';
import { t } from 'i18next';
import Styles from './WorklistFooter.module.scss';

const {
    scrollableContent: scrollableContentStyle,
} = Styles;

export interface WorklistSelectionActionsOverflowMenuProps {
    handleMarkAsReady: () => Promise<void>;
    labelsAssignedToSelectedOrders: [] | Label[];
    removeLabelFromOrders: (labelId: number) => Promise<void>;
    anySelected: boolean;
}

export const WorklistSelectionActionsOverflowMenu = (props: WorklistSelectionActionsOverflowMenuProps): React.ReactElement => {
    const {
        handleMarkAsReady,
        labelsAssignedToSelectedOrders,
        removeLabelFromOrders,
        anySelected,
    } = props;

    const anyLabelsAssignedInSelection = !!labelsAssignedToSelectedOrders.length;

    const actionsOverflowTriggerButton = (
        <div>
            <DobButton icon="three-dots-vertical" disabled={!anySelected} outline />
        </div>
    );

    return (
        <DobDropdownMenu
            side="top"
            sideOffset={5}
            disabled={!anySelected}
            trigger={actionsOverflowTriggerButton}
        >
            { anyLabelsAssignedInSelection && <RemoveLabelActionSubMenu labelsAssignedToSelectedOrders={labelsAssignedToSelectedOrders} removeLabelFromOrders={removeLabelFromOrders} />}
            <SetReadyForInvoicingActionOption handleMarkAsReady={handleMarkAsReady} />
            <DobDropdownMenuArrow />
        </DobDropdownMenu>
    );
};

const SetReadyForInvoicingActionOption = ({ handleMarkAsReady }: { handleMarkAsReady: () => Promise<void> }) => {
    return (
        <DobDropdownMenuItem onClick={() => void handleMarkAsReady()}> {t('MarkAsReadyForInvoicing')}</DobDropdownMenuItem>
    );
};

const RemoveLabelActionSubMenu = (props: {
    labelsAssignedToSelectedOrders: [] | Label[];
    removeLabelFromOrders: (labelId: number) => Promise<void>;
}): React.ReactElement => {
    const { labelsAssignedToSelectedOrders, removeLabelFromOrders } = props;

    return (
        <DobDropdownMenuSub>
            <DobDropdownMenuSubTrigger>{t('RemoveLabel')}</DobDropdownMenuSubTrigger>
            <DobDropdownMenuSubContent sideOffset={5} alignOffset={-5} className={scrollableContentStyle}>
                {labelsAssignedToSelectedOrders.length > 0
                    && labelsAssignedToSelectedOrders.map((label) => (
                        <DobDropdownMenuItem title={t('UnassignLabelFromAllSelected')} key={label.ID} onClick={() => void removeLabelFromOrders(label.ID)}>
                            {label.Name}
                        </DobDropdownMenuItem>
                    ))}
            </DobDropdownMenuSubContent>
        </DobDropdownMenuSub>
    );
};

export default WorklistSelectionActionsOverflowMenu;
